const ITEMS = {
  OVERVIEW: 'OVERVIEW',
  NOTES: 'NOTES',
  DISCUSSION: 'DISCUSSION',
  REVIEW: 'REVIEW'
}

export { ITEMS }
